import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import EditorialMarquee from "../components/EditorialMarquee";
import AboutResearch from "../components/AboutResearch";
import SurveySection from "../components/SurveySection";
import NewsSection from "../components/NewsSection";
import VoicesSection from "../components/VoicesSection";
import QuizSection from "../components/QuizSection";
import TournamentsSection from "../components/TournamentsSection";
import PointsTableSection from "../components/PointsTableSection";
import LeadingStatsSection from "../components/LeadingStatsSection";
import SitemapSection from "../components/SitemapSection";
import Footer from "../components/Footer";

const Home = () => (
  <div className="min-h-screen bg-cream dark:bg-background text-foreground transition-colors">
    <Navbar />
    <main className="overflow-x-clip">
      <HeroSection />
      <EditorialMarquee />
      <AboutResearch />
      <SurveySection />
      <NewsSection />
      <VoicesSection />
      <QuizSection />
      <section id="tables" className="relative pt-8 md:pt-12 pb-6 scroll-mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
          <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-pitch dark:text-turf">Matchday in Morbi</p>
        </div>
      </section>
      <TournamentsSection />
      <PointsTableSection />
      <LeadingStatsSection />
      <SitemapSection />
    </main>
    <Footer />
  </div>
);

export default Home;
